import axios from "axios";

export function apiRecupEspacesColidee(formData) {
  return axios
    .post(
      process.env.REACT_APP_URL_COLIDEE + "apiGetAllEspacesByOrganismeArrayFromEasyGouv",
      formData,
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiRecupActualitesColidee(token, formData) {
  return axios
    .post(
      process.env.REACT_APP_URL_COLIDEE +
        "apiGetMediasActusEventsFromEasyGouv/actus?token=" +
        token,
      formData,
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiRecupEvenementsColidee(token, formData) {
  return axios
    .post(
      process.env.REACT_APP_URL_COLIDEE +
        "apiGetMediasActusEventsFromEasyGouv/events?token=" +
        token,
      formData,
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}
export function apiRecupGaleriesColidee(token, formData) {
  return axios
    .post(
      process.env.REACT_APP_URL_COLIDEE +
        "apiGetMediasActusEventsFromEasyGouv/medias?token=" +
        token,
      formData,
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}
export function apiRecupEspacesGrantedColidee(token, formData) {
  return axios
    .post(
      process.env.REACT_APP_URL_COLIDEE + "apiGetEspacesGrantedFromEasyGouv?token=" + token,
      formData,
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiGetContribsEspacePrincipalColidee(token, formData) {
  return axios
    .post(
      process.env.REACT_APP_URL_COLIDEE +
        "/apiGetContribsEspacePrincipalColideeFromEasyGouv?token=" +
        token,
      formData,
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiGetLastContribsOnEspacesColidee(token, formData) {
  return axios
    .post(
      process.env.REACT_APP_URL_COLIDEE +
        "/apiGetLastContribsOnEspacesColideeFromEasyGouv?token=" +
        token,
      formData,
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiGetLastContribByUsers(token, formData) {
  return axios
    .post(
      process.env.REACT_APP_URL_COLIDEE +
        "apiGetLastContribForUserOnEspaceColideeFromEasyGouv?token=" +
        token,
      formData,
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiGetAllContribByUsersByEspaces(token, formData) {
  return axios
    .post(
      process.env.REACT_APP_URL_COLIDEE +
        "apiGetLastContribForUserOnAllEspacesColideeFromEasyGouv?token=" +
        token,
      formData,
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiControlIdsColidee(token, formData) {
  return axios
    .post(
      process.env.REACT_APP_URL_COLIDEE + "apiControlIdsColideeFromEasygouv?token=" + token,
      formData,
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiBandeauxColidee(token, formData) {
  return axios
    .post(
      process.env.REACT_APP_URL_COLIDEE + "apiBandeauxColideeFromEasygouv?token=" + token,
      formData,
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}
